import * as React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const renderSingleSelectOptions = (option) =>
    (
        <MenuItem key={option} value={option}>
            {option}
        </MenuItem>
    );

export function GridEditSingleSelectCell(props) {
    const {
        id,
        value,
        formattedValue,
        api,
        field,
        row,
        colDef,
        cellMode,
        isEditable,
        tabIndex,
        className,
        getValue,
        hasFocus,
        rowNode,
        isProcessingProps,
        ...other
    } = props;

    const ref = React.useRef();
    const [open, setOpen] = React.useState(false);

    const handleChange = (event) => {
        setOpen(false);
        api.setEditCellValue({ id, field, value: event.target.value }, event);
    };

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    React.useEffect(() => {
        if (hasFocus && ref.current) {
            const button = ref.current.querySelector('[role="button"]');
            if (button) {
                button.focus();
            }
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[hasFocus]);

    return (
        <Select
            ref={ref}
            value={value}
            onChange={handleChange}
            open={open}
            onOpen={handleOpen}
            MenuProps={{
                onClose: handleClose,
            }}
            fullWidth
            {...other}
        >
            {(colDef.valueOptions || colDef?.getValueOptions(row) || [])?.map(renderSingleSelectOptions)}
        </Select>
    );
}
export const renderEditSingleSelectCell = (params) => <GridEditSingleSelectCell {...params} />;